import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
  selected: {},
};

const getKey = (carriageId, railwayId) => `${carriageId}-${railwayId}`;

const selectionSlice = createSlice({
  name: 'selection',
  initialState,
  reducers: {
    toggle: (state, action) => {
      const { carriageId, railwayId, inspectionId } = action.payload;
      const key = getKey(carriageId, railwayId);
      if (state.selected[key]) {
        delete state.selected[key];
      } else {
        state.selected[key] = { carriageId, railwayId, inspectionId };
      }
    },
    add: (state, action) => {
      const key = getKey(action.payload.carriageId, action.payload.railwayId);
      state.selected[key] = {
        carriageId: action.payload.carriageId,
        railwayId: action.payload.railwayId,
        inspectionId: action.payload.inspectionId,
      };
    },
    remove: (state, action) => {
      const key = getKey(action.payload.carriageId, action.payload.railwayId);
      delete state.selected[key];
    },
    clear: (state) => {
      state.selected = {};
    },
  },
});

export const { toggle, add, remove, clear } = selectionSlice.actions;
export const selectIsSelected = (state, carriageId, railwayId) =>
  !!state.selection.selected[getKey(carriageId, railwayId)];
export const selectAll = createSelector(
  (state) => state.selection.selected,
  (selected) => Object.values(selected)
);
export const selectCount = createSelector(selectAll, (all) => all.length);
export default selectionSlice.reducer;
